define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var RecurringCalcModel = /** @class */ (function () {
        function RecurringCalcModel(data) {
            this.CustomerId = ko.observable(0);
            this.CalcDate = ko.observable();
            this.UpdateRecurring = ko.observable(false);
            this.SendEmail = ko.observable(false);
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, RecurringCalcModel.Mapping, self);
            }
        }
        RecurringCalcModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new RecurringCalcModel(options.data);
            }
        };
        return RecurringCalcModel;
    }());
    return RecurringCalcModel;
});
//# sourceMappingURL=RecurringCalcModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/RecurringCalcModel.js
// module id = 200
// module chunks = 2